import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ApiService } from '../services/apiEndpoints';
import './GuestDashboard.css';

const GuestDashboard = () => {
  const navigate = useNavigate();

  // State
  const [totalSeats, setTotalSeats] = useState(70);
  const [assignedSeats, setAssignedSeats] = useState(0);
  const [availableSeats, setAvailableSeats] = useState(70);
  const [loading, setLoading] = useState(true);
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    // 1. Splash Screen Timer (Matches your 1800ms delay)
    const splashTimer = setTimeout(() => {
      setShowSplash(false);
    }, 1800);

    // 2. Fetch Seat Stats
    const fetchStats = async () => {
      // Render can briefly take time to wake after inactivity. Retry once before
      // using the existing fallback values.
      try {
        for (let attempt = 0; attempt < 2; attempt += 1) {
          try {
            const res = await ApiService.getSeatStats();
            if (res.data) {
              setTotalSeats(res.data.totalSeats ?? 70);
              setAssignedSeats(res.data.assignedSeats ?? 0);
              setAvailableSeats(res.data.availableSeats ?? 70);
            }
            return;
          } catch (error) {
            if (attempt === 1) {
              console.error("Failed to fetch seat stats", error);
            } else {
              await new Promise((resolve) => setTimeout(resolve, 1500));
            }
          }
        }
      } finally {
        setLoading(false);
      }
    };

    fetchStats();

    return () => clearTimeout(splashTimer);
  }, []);

  // -------- SPLASH SCREEN --------
  if (showSplash) {
    return (
      <div className="splash-screen">
        <div className="splash-content">
          <img 
            src="/assets/logo.png" 
            alt="Utkarsh Logo" 
            className="splash-logo scale-in"
          />
          <h1 className="splash-title">Utkarsh Abhyasika</h1>
        </div>
      </div>
    );
  }

  // -------- DASHBOARD (Main Screen) --------
  return (
    <div className="guest-dashboard">
      <div className="dashboard-content">
        
        <img 
          src="/assets/logo.png" 
          alt="Utkarsh Logo" 
          className="dashboard-logo"
        />
        
        <h1 className="dashboard-title">Utkarsh Abhyasika</h1>

        <div className="stats-container">
          {loading ? (
            <div className="guest-spinner" aria-label="Loading seat availability"></div>
          ) : (
            <>
              {/* Total Seats Card */}
              <div className="simple-card total-card">
                <span className="card-label">Total Seats:</span>
                <span className="card-value">{totalSeats}</span>
              </div>

              {/* Occupied Seats Card */}
              <div className="simple-card occupied-card">
                <span className="card-label">Occupied Seats:</span>
                <span className="card-value">{assignedSeats}</span>
              </div>

              {/* Available Seats Card */}
              <div className="simple-card available-card">
                <span className="card-label">Available Seats:</span>
                <span className="card-value">{availableSeats}</span>
              </div>
            </>
          )}
        </div>

        <div className="action-buttons">
          <button 
            className="primary-button"
            onClick={() => navigate('/app/register')}
          >
            Register
          </button>
          
          <button 
            className="outlined-button"
            onClick={() => navigate('/app/signin')}
          >
            Sign In
          </button>
        </div>

      </div>
    </div>
  );
};

export default GuestDashboard;
